import styled from "styled-components";
import {
	COLOR_ERROR_RED,
	COLOR_WHITE,
	FONT_WT_LIGHT,
} from "@website-builder/utilities-index";

export const InputWrapper = styled.div`
	position: relative;
	width: 100%;
	.error-icon {
		color: ${COLOR_ERROR_RED};
		position: absolute;
		right: 18px;
		top: 15px;
		font-size: 18px;
		display: block;
		&.fa {
			font-size: 16px;
		}
		font-family: FontAwesome !important;
	}
	label.input-error {
		background-color: ${COLOR_ERROR_RED};
		color: ${COLOR_WHITE} !important;
		/* float: right; */
		padding: 2px 10px;
		border-radius: 4px;
		position: relative;
		margin-bottom: 9px;
		font-size: 12px;
		z-index: 100;
		top: -34px;
		right: -3px;
		position: absolute;
		&:after {
			content: "";
			position: absolute;
			right: 20px;
			top: 100%;
			width: 0;
			height: 0;
			border-left: 8px solid transparent;
			border-right: 8px solid transparent;
			border-top: 8px solid ${COLOR_ERROR_RED};
			clear: both;
		}
	}

	label.input-error-pos {
		position: absolute;
		right: -5px;
		bottom: 43px;
	}
`;
